export const getAppointmentFlowId = state => state.appointmentFlows.appointmentFlow.id;
export const getAppointmentFlowEmail = state => state.appointmentFlows.appointmentFlow.email;
export const getAppointmentFlowData = state => state.appointmentFlows.appointmentFlow;
export const appointmentFlowIsFetching = state => state.appointmentFlows.loading;
